import { CERTIFICATIONS_PATHS } from "@src/backpack-console/pages/Certifications/CertificationsBreadcrumbs";
import { EQUIPMENT_PATHS } from "@src/backpack-console/pages/Equipment/EquipmentBreadcrumbs";
import { PROJECT_PATHS } from "@src/backpack-console/pages/Projects/utils";
import { useCallback, useMemo } from "react";
import { generatePath, matchPath, useLocation } from "react-router-dom";

const equipmentPaths = Object.values(EQUIPMENT_PATHS);
const certificationsPaths = Object.values(CERTIFICATIONS_PATHS);
const projectsPaths = Object.values(PROJECT_PATHS);
function useMatchFeatureRoutes(routes: string[]) {
  const location = useLocation();
  return useMemo(
    () =>
      routes.some((path) =>
        matchPath(location.pathname, { path, exact: true, strict: false })
      ),
    [location.pathname, routes]
  );
}

// Returns a function that returns the pathname to the site-specific page most relevant to the current route
export function useGetPathnameToSite() {
  const location = useLocation();
  const equipmentMatch = useMatchFeatureRoutes(equipmentPaths);
  const certificationsMatch = useMatchFeatureRoutes(certificationsPaths);
  const projectsMatch = useMatchFeatureRoutes(projectsPaths);

  return useCallback(
    (siteId: number) => {
      // if already on the equipment, certifications, or projects routes routes then keep the same route
      if (equipmentMatch) {
        return generatePath(EQUIPMENT_PATHS.SITE_PAGE, { siteId });
      }
      if (certificationsMatch) {
        return generatePath(CERTIFICATIONS_PATHS.SITE_PAGE, { siteId });
      }
      if (projectsMatch) {
        return generatePath(PROJECT_PATHS.SITE_PAGE, { siteId });
      }
      if (location.pathname.includes("site")) {
        return location.pathname.replace(
          siteId ? /^\/site\/\d+/ : /.*/,
          `/site/${siteId}`
        );
      }
      return `/site/${siteId}`;
    },
    [certificationsMatch, equipmentMatch, projectsMatch, location.pathname]
  );
}
